import React from 'react';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import { TourWrapper } from './components/SidebarTour';
import { Outlet } from 'react-router-dom';
const AppLayout = () => {
  return (
    <TourWrapper>
      <Header />
      <Sidebar
        id="menu-item"
        id1="menu-items"
        activeClassName="admin-dashboard"
      />
      <div className="page-wrapper">
        <div className="content">
          <Outlet/>
        </div>
      </div>
    </TourWrapper>
  );
};

export default AppLayout;
